import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';

import { UIHeading4, UIText1 } from '@cian/ui-kit';

interface IListCardProps {
  address: string;
  title: string;
  isActive: boolean;
  redPoint: boolean;
  onClick(): void;
}

export const ListCard: React.FC<IListCardProps> = ({ address, title, isActive, redPoint, onClick }) => {
  return (
    <div
      data-testid="ListCard"
      className={cn(styles['container'], isActive && styles['container-active'])}
      onClick={onClick}
    >
      {redPoint && <div className={styles['red-point']} />}
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      <div className={styles['address']}>
        <UIText1 as="span" color="text-secondary-default">
          {address}
        </UIText1>
      </div>
    </div>
  );
};

ListCard.displayName = 'ListCard';
